import axios from '@/axios.js'

export default {
  // eslint-disable-next-line no-unused-vars
  fetchEmployees (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/employee')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchProfile (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v1/auth/profile')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateProfile (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/auth/profile', payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findEmployee (context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/v1/employee/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createEmployee (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v1/employee', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateEmployee (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/v1/employee/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteEmployee (context, id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/api/v1/employee/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
